import type { Meeting } from '@clareefai/types';

export interface ProposedDate {
  id: string;
  meetingId: string;
  date: string;
  time: string;
}

export interface UpcomingMeeting {
  id: string;
  date: string;
  time: string;
  type: string;
}

export interface PastMeeting {
  id: string;
  promoterName: string;
  date: string;
  time: string;
  outcome: string;
}

export function requestedDatesFor(meetings: Meeting[], promoterId: string): ProposedDate[] {
  return meetings
    .filter(m => m.promoter_id === promoterId && m.status === 'request' && m.requested_dates?.length)
    .flatMap(m => m.requested_dates.map(d => ({ id: d.id, meetingId: m.id, date: d.date, time: d.time })));
}

export function upcomingMeetingFor(meetings: Meeting[], promoterId: string): UpcomingMeeting | null {
  const meeting = meetings.find(m => m.promoter_id === promoterId && m.status === 'booked' && m.accepted_date);
  if (!meeting?.accepted_date) return null;
  return {
    id: meeting.id,
    date: meeting.accepted_date.date,
    time: meeting.accepted_date.time,
    type: meeting.type || 'Meeting',
  };
}

export function rescheduledDatesFor(meetings: Meeting[], promoterId: string): ProposedDate[] {
  return meetings
    .filter(m => m.promoter_id === promoterId && m.rescheduled_dates?.length)
    .flatMap(m => m.rescheduled_dates.map(d => ({ id: d.id, meetingId: m.id, date: d.date, time: d.time })));
}

export function completedMeetingsOf(meetings: Meeting[]): PastMeeting[] {
  return meetings
    .filter(m => m.status === 'completed')
    .map(m => ({
      id: m.id,
      promoterName: m.promoter_name || m.promoterName || 'Unknown',
      date: m.date || m.accepted_date?.date || '',
      time: m.time || m.accepted_date?.time || '',
      outcome: m.outcome || 'Completed',
    }));
}
